// src/untils/AgeInfo.js

import React from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

// Data for Age Points Without Spouse (Single Applicant)
const agePointsWithoutSpouse = [
  { age: '18 or 19', points: 0 },
  { age: '20', points: 90 },
  { age: '21', points: 95 },
  { age: '22', points: 100 },
  { age: '23', points: 105 },
  { age: '24', points: 110 },
  { age: '25', points: 110 },
  { age: '26', points: 110 },
  { age: '27', points: 110 },
  { age: '28', points: 110 },
  { age: '29', points: 110 },
  { age: '30', points: 105 },
  { age: '31', points: 99 },
  { age: '32', points: 94 },
  { age: '33', points: 88 },
  { age: '34', points: 83 },
  { age: '35', points: 77 },
  { age: '36', points: 72 },
  { age: '37', points: 66 },
  { age: '38', points: 61 },
  { age: '39', points: 55 },
  { age: '40', points: 50 },
  { age: '41', points: 39 },
  { age: '42', points: 28 },
  { age: '43', points: 17 },
  { age: '44', points: 6 },
  { age: '45+', points: 0 },
];

// Data for Age Points With Spouse
const agePointsWithSpouse = [
  { age: '18 or 19', points: 0 },
  { age: '20', points: 80 },
  { age: '21', points: 85 },
  { age: '22', points: 90 },
  { age: '23', points: 94 },
  { age: '24', points: 99 },
  { age: '25', points: 99 },
  { age: '26', points: 99 },
  { age: '27', points: 99 },
  { age: '28', points: 99 },
  { age: '29', points: 99 },
  { age: '30', points: 94 },
  { age: '31', points: 88 },
  { age: '32', points: 83 },
  { age: '33', points: 77 },
  { age: '34', points: 72 },
  { age: '35', points: 66 },
  { age: '36', points: 61 },
  { age: '37', points: 55 },
  { age: '38', points: 50 },
  { age: '39', points: 39 },
  { age: '40', points: 28 },
  { age: '41', points: 17 },
  { age: '42', points: 6 },
  { age: '43+', points: 0 },
];
const AgePointsComponent = ({ formData, calculateAgePoints }) => (
    <Box>
      <Typography variant="h6">Age Points</Typography>
      <Typography>
        Age is a key factor in the Comprehensive Ranking System (CRS). Applicants between 20 and 29 years receive the maximum points,
        with the points gradually decreasing outside this range.
      </Typography>
      {formData?.age && (
        <Typography sx={{ marginTop: 2 }}>
          Your points for age: {calculateAgePoints(formData.age)}
        </Typography>
      )}
  
      {/* Combined Age Points Breakdown */}
      <Typography variant="subtitle1" sx={{ marginTop: 2 }}>
        Age Points Breakdown
      </Typography>
      <TableContainer component={Paper} sx={{ marginTop: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Age</TableCell>
              <TableCell align="right">Points (Without Spouse)</TableCell>
              <TableCell align="right">Points (With Spouse)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {agePointsWithoutSpouse.map((row, index) => (
              <TableRow key={row.age}>
                <TableCell component="th" scope="row">
                  {row.age}
                </TableCell>
                <TableCell align="right">{row.points}</TableCell>
                <TableCell align="right">
                  {agePointsWithSpouse[index]?.points || "-"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );  

export default AgePointsComponent;
